<template>
  <div>
    <div>
      loading...
    </div>
  </div>
</template>

<script>
import services from '@/services'
export default {
  name: 'GoogleAuth',
  mounted() {
    // Preparação de objetos que levarão ao backend informações de login na socialmedia
    // Objeto onde irão ficar os parâmetros de retorno
    let params = {}
    // Parametrosd de retorno presentes na URL
    let hash = this.$route.hash
    // Removendo a cerquilha(#)
    hash = hash.replace('#', '')

    // Separando e armazenando os parâmetros de retorno
    hash.split('&').forEach(item => {
      let parts = item.split('=')
      params[parts[0]] = decodeURI(parts[1])
    })

    this.$store
      .dispatch('auth/loginExternalGoogle', params.access_token)
      .then(resp => {
        // Caso possua cadastro
        if (resp.success) {
          // Verifica se o utilizador possui mais de uma organization
          services
            .getUserOrganizations(this.$store.state.auth.user.id, null, 1, 10)
            .then(res => {
              let list = res.data.data.items

              if (Array.isArray(list)) {
                // Caso possua apenas uma organização, redireciona para home
                if (list.length === 1) {
                  this.$store
                    .dispatch('auth/selectOrganization', { value: list[0].organizationId })
                    .then(res => {
                      this.$router.push({ name: 'home' })
                    })
                    .catch(error => {
                      console.log('Erro dispatch', error)
                    })

                  // Caso possua mais de uma organização, redireciona para ecrã de seleção de organização
                } else {
                  this.$router.push({ name: 'OrganizationSelection' })
                }
              }
            })
            .catch(err => {
              console.log('Erro', err)
            })
        } else {
          this.$router.push({
            name: 'NewRegister-External',
            params: {
              name: encodeURI(resp.data.name),
              email: encodeURI(resp.data.email),
            },
          })
        }
      })
      .catch(err => {
        switch (err.errorCode) {
          case 6031:
            if (Array.isArray(err.errorParameters)) {
              if (err.errorParameters.length > 0) {
                try {
                  let errorData = JSON.parse(err.errorParameters[0])
                  this.$store.commit('auth/UPDATE_REGISTER_STEP', errorData)
                  this.$router.push({ name: 'BusinessProfile' })
                  return
                } catch (error) {
                  // TODO tratar
                }
              } else {
                this.$router.push({ name: 'Login' })
              }
            } else {
              this.$router.push({ name: 'Login' })
            }
            break
          case 10033:
            if (Array.isArray(err.errorParameters)) {
              if (err.errorParameters.length > 0) {
                try {
                  let errorData = JSON.parse(err.errorParameters[0])
                  this.$store.commit('auth/UPDATE_REGISTER_STEP', errorData)
                  this.$router.push({ name: 'ConfirmRegister' })
                  return
                } catch (error) {
                  // TODO tratar
                }
              } else {
                this.$router.push({ name: 'Login' })
              }
            } else {
              this.$router.push({ name: 'Login' })
            }
            break
          default:
            this.$router.push({ name: 'Login' })
            break
        }

        this.$router.push({ name: 'Login' })
      })
  },
}
</script>

<style scoped></style>
